import type { VoidComponent } from "solid-js";
import { Show } from "solid-js";
import { TextAndIconButton } from "../components/button/Button";
import { useTranslation } from "../state/i18n";
import { useAuthDispatch, useAuthState } from "../state/auth";

const StopImpersonationButton: VoidComponent = () => {
  const { t } = useTranslation();
  const { impersonation } = useAuthState();
  const { stopImpersonation } = useAuthDispatch();

  return (
    <Show when={impersonation()}>
      <TextAndIconButton
        variant="primary"
        color="destructive"
        icon="logout"
        text={t(($) => $.STOP_IMPERSONATION_BUTTON_LABEL)}
        onClick={() => stopImpersonation()}
      />
    </Show>
  );
};

export default StopImpersonationButton;
